import * as z from 'zod';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { Form } from '@/components/ui/form';

import OnBoardingContainer from '../../../components/on-boarding';
import { SelectForm } from './SelectForm';
import { useOnBoardingV5 } from '../hooks/useOnBoardingV5';
import { getAuthentication } from '@/hooks/useAuthentication';
import { updateProfile } from '@/services/on-boarding/onboarding.service';
import { useToast } from '@/components/ui/use-toast';
import { OnBoardingPage } from '@edwin-group/cj-graphql';
// import InputForm from './InputForm';

const schema = z.object({
  role: z.string({
    required_error: 'Please select a role.',
  }),
  ageBracket: z.string({
    required_error: 'Please select the age bracket.',
  }),
  gender: z.string({
    required_error: 'Please select the gender.',
  }),
  // location: z.string({
  //   required_error: 'Please select the location.',
  // }),
});

export type SchemaInput = z.infer<typeof schema>;

export default function OnBoardingStep4() {
  const { page, step4, completeStep } = useOnBoardingV5(4);
  const { toast } = useToast();

  const form = useForm({
    resolver: zodResolver(schema),
  });

  const { getValues } = form;

  const handleSubmit = async () => {
    const values = getValues();
    if (!values.gender) {
      toast({
        description: 'Please select the gender',
        variant: 'destructive',
      });
      return;
    }

    if (!values.role) {
      toast({
        description: 'Please select a role',
        variant: 'destructive',
      });
      return;
    }

    if (!values.ageBracket) {
      toast({
        description: 'Please select the age bracket',
        variant: 'destructive',
      });
      return;
    }

    // if (!values.location) {
    //   toast({
    //     description: 'Please select the location',
    //     variant: 'destructive',
    //   });
    //   return;
    // }

    const { user } = getAuthentication();
    if (!user) return;
    await updateProfile(user.id || '', values.role, values.gender, values.location, values.ageBracket);
    await completeStep();
  };

  const renderContent = () => {
    return (
      <Form {...form}>
        <form className="mb-8 mt-4 flex flex-col justify-center gap-[20px] md:max-w-[358px]">
          <SelectForm
            label={step4?.gender?.label}
            placeholder={step4?.gender?.placeholder}
            options={step4?.gender?.options?.map((option) => option!.option!)}
            onClickOption={form.setValue}
            control={form.control}
            name="gender"
          />
          <SelectForm
            label={step4?.role?.label}
            placeholder={step4?.role?.placeholder}
            options={step4?.roles?.map((role) => role!.role!)}
            onClickOption={form.setValue}
            control={form.control}
            name="role"
          />
          <SelectForm
            label={step4?.ageBracket?.label}
            placeholder={step4?.ageBracket?.placeholder}
            options={step4?.ageBracket?.options?.map((option) => option!.option!)}
            onClickOption={form.setValue}
            control={form.control}
            name="ageBracket"
          />
          {/* <InputForm
            label={step4?.location?.label || ''}
            placeholder={step4?.location?.placeholder || ''}
            setValue={form.setValue}
            watch={form.watch}
            name="location"
          /> */}
        </form>
      </Form>
    );
  };

  return (
    <OnBoardingContainer
      page={page as OnBoardingPage}
      step={3}
      image={step4.content?.image?.url || ''}
      title={step4?.content?.title || ''}
      content={renderContent()}
      button={{
        text: step4?.content?.button?.text || '',
        onClick: handleSubmit,
      }}
    />
  );
}
